import { Injectable } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Utilities } from "../../utils/utilities"

@Injectable({
  providedIn: 'root'
})
export class AttachmentUrlService {

  constructor(public translate: TranslateService) {
  }

  getVideoUrl(localization) {
    return Utilities.getServiceUrl() + 'download/video/' + this.getLocalizationElement(localization).slug;
  }

  private getLocalizationElement(localization) {
    return localization[this.translate.currentLang]?localization[this.translate.currentLang]:localization['hu'];
  }

  getSvgImageUrl(localization) {
    return Utilities.getServiceUrl() + 'download/img/' + this.getLocalizationElement(localization).slug;
  }

  getScaleWidthImageUrl(localization, width) {
    return Utilities.getServiceUrl() + 'download/img/scale/width/' + width + "/" + this.getLocalizationElement(localization).slug;
  }

  getScaleHeightImageUrl(localization, height) {
    return Utilities.getServiceUrl() + 'download/img/scale/height/' + height + "/" + this.getLocalizationElement(localization).slug;
  }

  getDownloadUrl(localization) {
    return Utilities.getServiceUrl() + 'dashboard/admin/row/' + this.getLocalizationElement(localization).slug;
  }

  getScaleWidthImageUrlBySlug(slug, width) {
    return Utilities.getServiceUrl() + 'download/img/scale/width/' + width + "/" + slug;
  }

}
